import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { MassiveUploadRecordPayload, MassiveUploadRecordResponse } from './massive-upload-record.types';

export async function silobagMassiveUploadRecordService({ body }: MassiveUploadRecordPayload) {
  const { response, data } = await BACKEND.post<MassiveUploadRecordResponse>(
    ENDPOINT.SILOBAGS_MASSIVE_RECORD,
    {
      body,
    }
  );

  return {
    response,
    summary: data,
  };
}
